/**
 * SyncComponent
 *
 * This component is responsible for displaying the synchronization status
 * and available sync services. It interacts with the server state to determine
 * the current status and updates accordingly.
 * ## User Interface
 * - Label: Sync data form source:
 * - MUI Dropdown for selecting sync services
 * - Start Button to start the synchronization process
 * - Label to display log message retrieved via a websocket.
 * 
 * ## Log behavoir
 * List all message form websocket that have message_type SYNC_MESSAGE, SYNC_START or SYNC_ERROR
 * 
 * ## API
 * - Use AdminService.postSync to start a synchronization process
 * - Use AdminService.listSyncServices to retrieve available sync services
 * - Connect to the websocket to receive log messages.
 */
import React, { useEffect, useRef, useState } from 'react';
import {
    Box,
    Button,
    CircularProgress,
    FormControl,
    InputLabel,
    List,
    ListItem,
    ListItemText,
    MenuItem,
    Paper,
    Select,
    Stack,
    Typography,
} from '@mui/material';
import { AdminService } from '../api-client/services/AdminService';
import type { ServiceInfo } from '../api-client/index';
import { SyncEventRequest, ValidationResponse } from '../api-client/index';
import type { Message, MessageType, WebSocketMessage } from '../api/websocket-types';
import { useINotify, Severity } from './iNotify';
const SYNC_MESSAGE_TYPES: MessageType[] = ['SYNC_START', 'SYNC_MESSAGE', 'SYNC_ERROR', 'SYNC_COMPLETE'];
import GrowingButton from './GrowingButton';
import { MinuteRunner } from './MinuteRunner';
import { useIntl } from 'react-intl';
import SessionContext, { type Session, defaultSession, useSession } from '../SessionContext';
interface MinuteRunnerProps {
    onMinute: () => void;
}


const CheckSyncComponent: React.FC = () => {
    const notify = useINotify();
    const [services, setServices] = useState<ServiceInfo[]>([]);
    const [selectedUrl, setSelectedUrl] = useState('');
    const [syncNeeded, setSyncNeeded] = useState(false);
    const intl = useIntl();
    const { session } = useSession();

    const onMinute = () => {
        AdminService.listSyncServices()
            .then((data) => {
                setServices(data ?? []);
                if (data?.length) {
                    setSelectedUrl((current) => current || data[0].url);
                    // handleSyncCheck(data[0].url);
                    data.map((service) => handleSyncCheck(service.url));
                }
            })
            .catch((error) => {
                console.error('Failed to load sync services:', error);
                setServices([]);
            });
    };

    useEffect(() => {
        onMinute();
    }, [session?.trigger_sync_check]);


    const handleSyncCheck = (url: string) => {
        if (!url) {
            return;
        }
        console.log(`Checking sync for URL: ${url}`);
        const request = { url } as SyncEventRequest;
        AdminService.postSyncCheck(request).then((reponse) => {
            const vr : ValidationResponse = reponse;
            setSyncNeeded(!vr.valid);
        });
    };





    return (
        <Box>
            <MinuteRunner onMinute={onMinute}>
            </MinuteRunner>
            {syncNeeded ? <GrowingButton state={syncNeeded} title={intl.formatMessage({ id: '__sync_available__' })} /> : null}
        </Box>

    );
};

export default CheckSyncComponent;

